import { TranslatableText, useTranslate } from '@dreryk/react-common';
import { AutoLayout, TestableComponentProps } from '@dreryk/react-components';

import { StyledFormSectionHeader } from '../../common/StyledFormSectionHeader';

import { HealthcareBasicData, HealthcareBasicDataPanel } from './HealthcareBasicData';

type HealthcareParentBasicDataPanelProps = TestableComponentProps & {
   readonly header: TranslatableText;
   readonly healthcareParentData: HealthcareBasicData;
};

export const HealthcareParentBasicDataPanel = (props: HealthcareParentBasicDataPanelProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <AutoLayout as={'div'} testId={props.testId} $direction={'vertical'} $spacing={12}>
         <StyledFormSectionHeader>{translate(props.header)}</StyledFormSectionHeader>
         <HealthcareBasicDataPanel testId={props.testId} {...props.healthcareParentData} />
      </AutoLayout>
   );
};
